import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogTaskAgentDelegated_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import ActivityLogBase from 'src/entities/ActivityLog/Helpers/ActivityLogBase';
import { useAiAgentLabel } from 'src/entities/ActivityLog/Helpers/useAiAgentLabel';

import useIsAiTaskEnabled from 'src/hooks/useIsAiTaskEnabled';

interface Fragments {
  activityLog: ActivityLogTaskAgentDelegated_ActivityLogFragment;
}

const ActivityLogTaskAgentDelegated: FCWithFragments<Fragments> = ({ activityLog }) => {
  const aiTaskEnabled = useIsAiTaskEnabled();
  const aiAgentLabel = useAiAgentLabel();
  if (!aiTaskEnabled) {
    return null;
  }

  return <ActivityLogBase activityLog={activityLog} actionLabel={`delegated to ${aiAgentLabel}`} />;
};

ActivityLogTaskAgentDelegated.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogTaskAgentDelegated_activityLog on ActivityLog {
      id
      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskAgentDelegated;
